import { render, staticRenderFns } from "./BaseAnimal.vue?vue&type=template&id=5bd0ffa9&scoped=true&"
import script from "./BaseAnimal.vue?vue&type=script&lang=js&"
export * from "./BaseAnimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0ffa9",
  null
  
)

export default component.exports